module.exports = __webpack_public_path__ + "img/拒绝.1b4d1f72.svg";